import type { CommunityChannelSearchItem } from '@ps/api/types';

import type { CommunityChannel } from '../../types/CommunityChannel';

/**
 * Narrow a search-API channel item to the slice's `CommunityChannel`
 * shape. Drops fields slice 1 doesn't need (typing state, presence,
 * `me.unreadMessageCount`, etc.) so the UI doesn't drift onto a wider
 * dependency surface than it actually uses.
 */
export function searchItemToChannel(
  item: CommunityChannelSearchItem,
): CommunityChannel {
  return {
    id: item.id,
    slug: item.slug,
    name: item.name,
    description: item.description,
    icon: item.icon,
    visibility: item.visibility,
    minimumSubscriptionLevel: item.minimumSubscriptionLevel,
    isBroadcastChannel: item.isBroadcastChannel ?? false,
    messageCount: item.messageCount,
    memberCount: item.memberCount,
    lastMessage: item.lastMessage,
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
  };
}
